(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 60872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(51669);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forgot_password; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPageHeader.jsx
var AuthPageHeader = __webpack_require__(52696);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPagePaper.jsx
var AuthPagePaper = __webpack_require__(55474);
// EXTERNAL MODULE: ./src/platform/views/Auth/components/AuthPageFooter.jsx
var AuthPageFooter = __webpack_require__(97360);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/platform/components/MessageBox/MessageBox.jsx
var MessageBox = __webpack_require__(43454);
// EXTERNAL MODULE: ./src/api/userApi.js
var userApi = __webpack_require__(62725);
// EXTERNAL MODULE: ./src/platform/components/Loader/Loader.jsx
var Loader = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./src/utils/serializeError.js
var serializeError = __webpack_require__(99584);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/input_field/index.jsx
var input_field = __webpack_require__(71493);
// EXTERNAL MODULE: ./node_modules/@demystdata/ui/button/index.jsx
var ui_button = __webpack_require__(58278);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/platform/views/Auth/ForgotPassword.jsx




















var ForgotPassword = function() {
    // "IDLE", "LOADING", "SUCCESS", "FAILED"
    var ref = (0,react.useState)("IDLE"), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), isCaptchaRequired = ref2[0], setIsCaptchaRequired = ref2[1];
    var ref3 = (0,react.useState)(null), captchaResponse = ref3[0], setCaptchaResponse = ref3[1];
    var submitButtonDisabled = status === "LOADING" || isCaptchaRequired && !captchaResponse;
    var onCaptchaChange = function(captchaResponse) {
        setCaptchaResponse(captchaResponse);
    };
    var checkIfCaptchaIsRequired = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var ref, next_submit_requires_captcha;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return userApi/* userApi.isForgotPasswordCaptchaNeeded */.B.isForgotPasswordCaptchaNeeded();
                    case 3:
                        ref = _ctx.sent;
                        next_submit_requires_captcha = ref.data.next_submit_requires_captcha;
                        if (next_submit_requires_captcha) {
                            setIsCaptchaRequired(true);
                        }
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function checkIfCaptchaIsRequired() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var form, email;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        _ctx.prev = 1;
                        setStatus("LOADING");
                        setError(null);
                        form = new FormData(event.target);
                        email = form.get("email");
                        _ctx.next = 8;
                        return userApi/* userApi.sendResetPasswordEmail */.B.sendResetPasswordEmail(email, captchaResponse);
                    case 8:
                        setStatus("SUCCESS");
                        _ctx.next = 17;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        setStatus("FAILED");
                        setError((0,serializeError/* serializeError */.X)(_ctx.t0));
                        _ctx.next = 17;
                        return checkIfCaptchaIsRequired();
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11
                ]
            ]);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        checkIfCaptchaIsRequired();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        role: "main",
        className: "ForgotPassword",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ForgotPassword__header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPageHeader/* AuthPageHeader */.w, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ForgotPassword__paper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthPagePaper/* AuthPagePaper */.v, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            className: "ForgotPassword__paper__header",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "ForgotPassword__paper__header__title",
                                    children: status !== "SUCCESS" ? "Forgot your password?" : "Check your email for instructions to reset your password!"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ForgotPassword__paper__header__message",
                                    children: [
                                        status === "SUCCESS" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Didn't get the email? Check your spam folder."
                                        }),
                                        status === "IDLE" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Enter the email address associated with your account and we'll send you a link to reset your password."
                                        })
                                    ]
                                })
                            ]
                        }),
                        status !== "SUCCESS" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handleSubmit,
                            className: "ForgotPasswordForm",
                            "data-test-id": "ForgotPasswordForm",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input_field/* default */.Z, {
                                    className: "ForgotPasswordForm__email",
                                    size: "regular",
                                    type: "email",
                                    name: "email",
                                    label: "Email",
                                    id: "email",
                                    required: true
                                }),
                                isCaptchaRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ForgotPasswordForm__captchaWrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                        sitekey: appConfig/* appConfig.CAPTCHA_KEY */.eG.CAPTCHA_KEY,
                                        onChange: onCaptchaChange
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                                    children: status === "FAILED" && error && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        className: "ForgotPasswordForm__errorMessageWrapper"
                                    }, appConfig/* animatePresenceConfig */.Rr), {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageBox/* MessageBox */._, {
                                            children: error.message
                                        })
                                    }))
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui_button/* default */.Z, {
                                    className: "ForgotPasswordForm__submitButton",
                                    "data-test-id": "ForgotPasswordSubmit",
                                    type: "submit",
                                    size: "large",
                                    variant: "primary",
                                    disabled: submitButtonDisabled,
                                    fullWidth: true,
                                    children: "Continue"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "ForgotPassword__paper__backLinks",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: linksConstants/* linksConstants.LOGIN */.s.LOGIN,
                                "data-test-id": "BackToLogin",
                                children: "Back to login"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* AnimatePresence */.M_, {
                            children: status === "LOADING" && /*#__PURE__*/ (0,jsx_runtime.jsx)(framer_motion_es/* motion.div */.ww.div, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                className: "ForgotPassword__paper__loadingOverlay"
                            }, appConfig/* animatePresenceConfig */.Rr), {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* Loader */.a, {})
                            }))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ForgotPassword__footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthPageFooter/* AuthPageFooter */.G, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/redux/Provider.js
var Provider = __webpack_require__(66884);
;// CONCATENATED MODULE: ./pages/forgot-password.jsx




var ForgotPasswordPage = function(param) {
    var initialReduxState = param.initialReduxState;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Provider/* default.Redux */.Z.Redux, {
        initialReduxState: initialReduxState,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/forgot-password",
                title: "Forgot Password"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPassword, {})
        ]
    });
};
/* harmony default export */ var forgot_password = (ForgotPasswordPage);


/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86010);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2777);




var Loader = function(param) {
    var className = param.className, _fullHeight = param.fullHeight, fullHeight = _fullHeight === void 0 ? false : _fullHeight, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _withPadding = param.withPadding, withPadding = _withPadding === void 0 ? false : _withPadding;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("Loader", fullHeight && "Loader--fullHeight", fullWidth && "Loader--fullWidth", withPadding && "Loader--withPadding", className),
        role: "progressbar",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_2__/* .FiLoader */ .dAq, {})
    });
};
Loader.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.string,
    fullHeight: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    fullWidth: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool,
    withPadding: prop_types__WEBPACK_IMPORTED_MODULE_3__.PropTypes.bool
};


/***/ }),

/***/ 52696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ AuthPageHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_linksConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71571);
/* harmony import */ var _assets_svg_DemystLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45911);




var AuthPageHeader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: "AuthPageHeader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            "aria-label": "Demyst logo",
            href: _constants_linksConstants__WEBPACK_IMPORTED_MODULE_2__/* .linksConstants.HOME */ .s.HOME,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svg_DemystLogo__WEBPACK_IMPORTED_MODULE_3__/* .DemystLogo */ .w, {})
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,8278,9440,2653,7467,9774,2888,179], function() { return __webpack_exec__(60872); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);